import * as Mtds from '@mattilsynet/design/react'
import { CalendarDotsIcon } from '@phosphor-icons/react'
import { getNearestDuedate, toLocaleDateString } from '../../utils/dateUtils'

type DuedateSummaryProps = {
  duedates?: string[] | null
  duedate?: string | null
  className?: string
  fallback?: string
  showLabel?: boolean
}

export const DuedateSummary = ({
  duedates,
  duedate,
  className,
  fallback,
  showLabel = true
}: DuedateSummaryProps) => {
  const nearestDuedate = duedate ?? getNearestDuedate(duedates)

  if (nearestDuedate == null) return fallback ?? null

  return (
    <Mtds.Flex data-align='center' className={className}>
      <CalendarDotsIcon />
      {showLabel && 'Innsendingsfrist: '}
      <span>{toLocaleDateString(nearestDuedate)}</span>
    </Mtds.Flex>
  )
}
